function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M22.5 31.7869L4.92188 21.0449V36.8652C4.92181 37.9012 5.33326 38.8948 6.06574 39.6275C6.79822 40.3601 7.79173 40.7718 8.82773 40.772H36.1723C37.2083 40.7718 38.2018 40.3601 38.9343 39.6275C39.6667 38.8948 40.0782 37.9012 40.0781 36.8652V21.0449L22.5 31.7869Z",
  fill: "#FFE39A"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M40.0781 19.7661V21.0458L33.0469 25.3428V14.5146L33.4934 14.7221L39.237 18.2667C39.4939 18.4236 39.7062 18.644 39.8535 18.9065C40.0007 19.1691 40.0781 19.4651 40.0781 19.7661Z",
  fill: "#F0B050"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M32.2726 11.7615L25.5138 4.2416L25.3723 4.22754H14.7401C14.0009 4.22768 13.2919 4.52148 12.7693 5.0443C12.2466 5.56713 11.953 6.27616 11.9531 7.01543V25.3424L22.5 31.7874L33.0469 25.3424V12.6246L32.2726 11.7615Z",
  fill: "white"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M11.9531 14.5146V25.3428L4.92188 21.0458V19.7661C4.9219 19.4651 4.99926 19.1691 5.14655 18.9065C5.29383 18.644 5.5061 18.4236 5.76299 18.2667L11.9531 14.5146Z",
  fill: "#F0B050"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M22.4979 25.9549C25.8623 25.9549 28.5896 23.2275 28.5896 19.8632C28.5896 16.4988 25.8623 13.7715 22.4979 13.7715C19.1336 13.7715 16.4062 16.4988 16.4062 19.8632C16.4062 23.2275 19.1336 25.9549 22.4979 25.9549Z",
  fill: "#FFC875"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.5306 4.24297L32.2744 11.7611H28.3026C27.9366 11.7611 27.5741 11.689 27.2359 11.5489C26.8977 11.4088 26.5904 11.2034 26.3316 10.9445C26.0728 10.6856 25.8675 10.3783 25.7275 10.0401C25.5875 9.70182 25.5155 9.33931 25.5156 8.97324V4.24121L25.5306 4.24297Z",
  fill: "#D9E1EB"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M7.55859 36.8652V22.6562L4.92188 21.0449V36.8652C4.92181 37.9012 5.33326 38.8948 6.06574 39.6275C6.79822 40.3601 7.79173 40.7718 8.82773 40.772H11.4645C10.4285 40.7718 9.43494 40.3601 8.70246 39.6275C7.96998 38.8948 7.55852 37.9012 7.55859 36.8652Z",
  fill: "#FFC875"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M21.5999 21.673C21.5236 21.6731 21.4483 21.6567 21.379 21.6248C21.3097 21.593 21.2481 21.5464 21.1986 21.4884L19.8451 19.9032C19.7542 19.7968 19.7094 19.6587 19.7204 19.5193C19.7314 19.3798 19.7973 19.2505 19.9037 19.1597C20.01 19.0688 20.1481 19.024 20.2875 19.035C20.427 19.0459 20.5563 19.1119 20.6472 19.2182L21.6667 20.412L24.4199 18.172C24.5284 18.0837 24.6675 18.0422 24.8066 18.0565C24.8755 18.0636 24.9423 18.0841 25.0033 18.1171C25.0642 18.15 25.118 18.1946 25.1618 18.2483C25.2055 18.302 25.2381 18.3638 25.258 18.4302C25.2778 18.4965 25.2843 18.5661 25.2773 18.635C25.2702 18.7039 25.2496 18.7707 25.2167 18.8317C25.1838 18.8926 25.1392 18.9465 25.0855 18.9902L21.9329 21.5551C21.8388 21.6316 21.7212 21.6733 21.5999 21.673Z",
  fill: "#3D639B"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M7.58594 27.9785C7.44608 27.9785 7.31194 27.923 7.21305 27.8241C7.11415 27.7252 7.05859 27.591 7.05859 27.4512V26.8975C7.05859 26.7576 7.11415 26.6235 7.21305 26.5246C7.31194 26.4257 7.44608 26.3701 7.58594 26.3701C7.7258 26.3701 7.85993 26.4257 7.95883 26.5246C8.05772 26.6235 8.11328 26.7576 8.11328 26.8975V27.4512C8.11328 27.591 8.05772 27.7252 7.95883 27.8241C7.85993 27.923 7.7258 27.9785 7.58594 27.9785Z",
  fill: "#F4F8FC"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M7.58594 35.5371C7.44608 35.5371 7.31194 35.4816 7.21305 35.3827C7.11415 35.2838 7.05859 35.1496 7.05859 35.0098V29.4727C7.05859 29.3328 7.11415 29.1987 7.21305 29.0998C7.31194 29.0009 7.44608 28.9453 7.58594 28.9453C7.7258 28.9453 7.85993 29.0009 7.95883 29.0998C8.05772 29.1987 8.11328 29.3328 8.11328 29.4727V35.0098C8.11328 35.1496 8.05772 35.2838 7.95883 35.3827C7.85993 35.4816 7.7258 35.5371 7.58594 35.5371Z",
  fill: "#F4F8FC"
});

var SvgEmailreminder = function SvgEmailreminder(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmailreminder, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/emailreminder.2e38e309.svg";
export { ForwardRef as ReactComponent };